// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react'

const IconLongArrowLeft = (props: React.HTMLAttributes<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      width: '1em',
      height: '1em',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.7071 6.7071C11.0976 6.31657 11.0976 5.6834 10.7071 5.29288C10.3166 4.90236 9.6834 4.90237 9.29288 5.29291L3.29288 11.2931C3.10535 11.4806 3 11.735 3 12.0002C3 12.2654 3.10537 12.5198 3.2929 12.7073L9.29291 18.7071C9.68344 19.0976 10.3166 19.0976 10.7071 18.7071C11.0976 18.3166 11.0976 17.6834 10.7071 17.2929L6.41407 13L20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11L6.41435 11L10.7071 6.7071Z',
      fill: 'currentColor',
    }),
  )

export { IconLongArrowLeft }
